<template>
  <router-view v-if="!isLoading" :hasProject="hasProject" />
</template>

<script>
import apiUsages from '@/api/usages';
export default {
  data() {
    return {
      isLoading: true
    };
  },
  computed: {
    hasProject() {
      return this.$store.getters['user/hasProject'];
    }
  },
  created() {
    // サイト数の利用量を取得するまでローダーを表示する
    this.$store.dispatch('view/setLoading', true);

    Promise.all([this.getUsagesCount(), this.getUsagesProject()])
      .then(response => {
        const count = response[0].data; //サイト登録回数
        const project = response[1].data.items[0]; //サイト数

        // サイト登録回数かサイト数が上限に達している場合は、ダッシュボードに遷移させる
        if (count.current >= count.max || project.current >= project.max) {
          this.goProjects();
        } else {
          this.$store.dispatch('view/setLoading', false);
        }
        this.isLoading = false;
      })
      .catch(error => {
        this.goError();
        this.isLoading = false;
      });
  },
  methods: {
    getUsagesCount() {
      let params = {
        items: 'project'
      };
      return apiUsages.count.get(params, this.auth.idToken);
    },
    getUsagesProject() {
      let params = {
        items: 'projects',
        projects: 'all'
      };
      return apiUsages.get(params, this.auth.idToken);
    },
    goProjects() {
      this.$router.push({ name: 'projects' });
    },
    goError() {
      this.$router.push({ name: 'error' });
    }
  }
};
</script>
